"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Lazy = void 0;
class Lazy {
    constructor(_factory, _disposer) {
        this._factory = _factory;
        this._disposer = _disposer;
        this._instance = null;
    }
    get hasValue() { return this._instance !== null; }
    get value() {
        this.ensureInstance();
        return this._instance;
    }
    /** Override me: additional way to make sure instance is valid */
    get isValid() { return this.hasValue; }
    ensureInstance() {
        if (this.isValid) {
            return;
        }
        // additional reset to make sure previous instance has been disposed
        this.reset();
        this._instance = this._factory();
    }
    prewarm() {
        this.ensureInstance();
        return this;
    }
    reset() {
        if (this.hasValue && this._disposer) {
            this._disposer(this._instance);
        }
        this._instance = null;
    }
    dispose() { this.reset(); }
}
exports.Lazy = Lazy;
//# sourceMappingURL=singleton.js.map